import global from './global/nl.json';
import placeholders from './input/placeholders/nl.json';
import errors from './input/errors/nl.json';
import labels from './input/labels/nl.json';
import notifications from './notifications/nl.json';
import idle from './idle/nl.json';
import start from './start/nl.json';
import draw from './draw/nl.json';
import invent from './invent/nl.json';
import share from './share/nl.json';
import share_link from './share-link/nl.json';
import share_sms from './share-sms/nl.json';
import share_email from './share-email/nl.json';
import souvenir from './souvenir/nl.json';
import drawing_ready from './drawing-ready/nl.json';
import invention_ready from './invention-ready/nl.json';
import page_not_found from './page-not-found/nl.json';

export default {
  global,
  notifications,
  idle,
  start,
  draw,
  drawing_ready,
  invention_ready,
  invent,
  share,
  share_link,
  share_sms,
  share_email,
  souvenir,
  page_not_found,
  input: {
    labels,
    placeholders,
    errors
  }
};
